import { load } from '@/router/routes/index';

export default [
    {
        path: 'newsletter',
        component: load('newsletter/NewsletterIndex'),
        meta: { auth: true },
        children: [
            {
                path: 'lists',
                name: 'newsletter.list.index',
                component: load('newsletter/NewsletterListIndex'),
                meta: { auth: true },
            },
            {
                path: 'lists/create',
                name: 'newsletter.list.create',
                component: load('newsletter/NewsletterListCreate'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
            {
                path: 'lists/:listId',
                component: load('newsletter/NewsletterListDetail'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        component: load('newsletter/NewsletterListShow'),
                        meta: { auth: true },
                        children: [
                            {
                                path: '',
                                name: 'newsletter.list.show',
                                component: load('newsletter/NewsletterListShowOverview'),
                                meta: { auth: true },
                            },
                            {
                                path: 'recipients',
                                name: 'newsletter.list.show.recipients',
                                component: load('newsletter/NewsletterListShowRecipients'),
                                meta: { auth: true },
                            },
                        ],
                    },
                    {
                        path: 'edit',
                        name: 'newsletter.list.edit',
                        component: load('newsletter/NewsletterListEdit'),
                        meta: { auth: true, forceCollapsedMenu: true },
                    },
                    {
                        path: 'groups/:groupId/edit',
                        name: 'newsletter.group.edit',
                        component: load('newsletter/NewsletterGroupEdit'),
                        meta: { auth: true, forceCollapsedMenu: true },
                    },
                ],
            },
            {
                path: 'groups/create',
                name: 'newsletter.group.create',
                component: load('newsletter/NewsletterGroupCreate'),
                props: true,
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },
];
